// extracted by mini-css-extract-plugin
module.exports = {"rootLoading":"FullPageLoading_rootLoading__2U8jm"};